<template>
    <div
        class="avatar-initials"
        :class="[sizeClass, customClass]"
        :style="avatarStyle"
    >
        <img
            v-if="hasImage"
            :src="src"
            :alt="name"
            class="avatar-img"
        >
        <span v-else class="avatar-initials-text">{{ initials }}</span>
    </div>
</template>

<script>
// Warna unik untuk setiap inisial (palet vibrant & konsisten)
const COLOR_PALETTE = [
    '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3',
    '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39',
    '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548',
    '#607D8B', '#F44336', '#E040FB', '#7C4DFF', '#536DFE',
    '#448AFF', '#18FFFF', '#64FFDA', '#69F0AE', '#B2FF59',
    '#EEFF41', '#FFD740', '#FFAB40', '#FF6E40', '#BCAAA4'
]

export default {
    name: 'Avatar',
    props: {
        src: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'md' // 2xs, xs, sm, md, lg, xl, profile
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        hasImage () {
            return this.src && this.src !== '' && this.src !== null
        },
        initials () {
            if (!this.name || this.name.trim() === '') return '?'
            const parts = this.name.trim().split(/\s+/)
            if (parts.length >= 2) {
                const first = parts[0].charAt(0)
                const last = parts[parts.length - 1].charAt(0)
                return (first + last).toUpperCase()
            }
            return this.name.substring(0, 2).toUpperCase()
        },
        bgColor () {
            const str = this.initials
            let hash = 0
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash)
            }
            const index = Math.abs(hash) % COLOR_PALETTE.length
            return COLOR_PALETTE[index]
        },
        avatarStyle () {
            if (this.hasImage) return {}
            return {
                backgroundColor: this.bgColor,
                color: '#fff'
            }
        },
        sizeClass () {
            const sizes = {
                '2xs': 'avatar-2xs',
                xs: 'avatar-xs',
                sm: 'avatar-sm',
                md: 'avatar-md',
                lg: 'avatar-lg',
                xl: 'avatar-xl',
                profile: 'avatar-profile'
            }
            return sizes[this.size] || 'avatar-md'
        }
    }
}
</script>

<style scoped>
.avatar-initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    overflow: hidden;
    flex-shrink: 0;
    font-weight: 600;
    text-transform: uppercase;
}

.avatar-initials.avatar-2xs {
    width: 1.75rem;
    height: 1.75rem;
    font-size: 0.5rem;
}

.avatar-initials.avatar-xs {
    width: 35px;
    height: 35px;
    font-size: 0.6rem;
}

.avatar-initials.avatar-sm {
    width: 2rem;
    height: 2rem;
    font-size: 0.65rem;
}

.avatar-initials.avatar-md {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 0.75rem;
}

.avatar-initials.avatar-lg {
    width: 4rem;
    height: 4rem;
    font-size: 1rem;
}

.avatar-initials.avatar-xl {
    width: 150px;
    height: 150px;
    font-size: 2rem;
}

.avatar-initials.avatar-profile {
    width: 100%;
    aspect-ratio: 1;
    font-size: 2rem;
}

.avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.avatar-initials-text {
    line-height: 1;
    user-select: none;
}
</style>
